<div class="sp-details-wrapper">
  @if (!details()) {
    <div class="loading">
      <nz-spin nzSimple nzSize="large" nzTip="Ładowanie danych podmiotu..." />
    </div>
  } @else {
    @let sp = details()!;
    <div class="sp-view">
      <!-- HERO -->
      <nz-card class="profile-card" [nzBordered]="false">
        <div class="profile-header">
          <div class="profile-icon">
            <span nz-icon nzType="shop" nzTheme="outline"></span>
          </div>
          <div class="profile-info">
            <h1 class="profile-name">{{ sp.name || '-' }}</h1>
            <div class="profile-meta">
              <nz-tag [nzColor]="typeColor()">
                <span nz-icon nzType="tag"></span>
                {{ typeLabel() }}
              </nz-tag>
              @if (sp.code) {
                <span class="badge">
                  <span nz-icon nzType="idcard"></span>
                  {{ sp.code }}
                </span>
              }
            </div>
            @if (sp.description) {
              <p class="profile-desc">{{ sp.description }}</p>
            }
          </div>
        </div>
      </nz-card>

      <!-- DETAILS GRID -->
      <nz-card class="form-card" [nzBordered]="false">
        <div class="card-section-header">
          <span nz-icon nzType="profile" nzTheme="outline" class="section-icon"></span>
          <span>Dane podmiotu</span>
        </div>
        <div class="details-grid">
          <div class="detail-item">
            <span class="detail-label">REGON</span>
            <span class="detail-value">{{ sp.regon || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">NIP</span>
            <span class="detail-value">{{ sp.taxId || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Nr rej.</span>
            <span class="detail-value">{{ sp.registryNumber || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Oddz. NFZ</span>
            <span class="detail-value">{{ sp.nhfBranchCode || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Telefon</span>
            <span class="detail-value">{{ sp.phone || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Adres</span>
            <span class="detail-value">{{ address() }}</span>
          </div>
        </div>
      </nz-card>
    </div>

    <div class="button-footer-wrapper">
      <a nz-button nzType="default" routerLink="/service-providers">
        <span nz-icon nzType="arrow-left"></span>
        Wstecz
      </a>
    </div>
  }
</div>
